export default {
  "paymentPlatformAdmin.thead.index": "#NO",
  "paymentPlatformAdmin.thead.documentId": "DocumentId",
  "paymentPlatformAdmin.thead.bindSite": "绑定站点",
  "paymentPlatformAdmin.thead.title": "支付平台名称",
  "paymentPlatformAdmin.thead.key": "支付平台Key",
  "paymentPlatformAdmin.thead.icon": "支付平台图标",
  "paymentPlatformAdmin.thead.logo": "支付平台Logo",
  "paymentPlatformAdmin.thead.active": "是否可用",
  "paymentPlatformAdmin.thead.autoLoop": "是否加入支付循环",
  "paymentPlatformAdmin.thead.payDesc": "支付描述",
  "paymentPlatformAdmin.thead.remark": "支付平台备注",
  "paymentPlatformAdmin.thead.sort": "排序",
  "paymentPlatformAdmin.thead.createdAt": "创建时间",
  "paymentPlatformAdmin.thead.updatedAt": "更新新时间",

  "paymentPlatformAdmin.add": "新增",
  "paymentPlatformAdmin.edit": "编辑",
  "paymentPlatformAdmin.details": "详情",
  "paymentPlatformAdmin.delete": "删除",
  "paymentPlatformAdmin.thead.action": "操作",
};
